<template>
    <div class="user-info">
        <div class="account" v-if="isLogin" @click="$router.push({ name: 'Profile'})">
            <div class="user_image">
                <div class="image_empty"  v-if="userModel.userImage===''"/>
                <el-image v-else :src="userModel.userImage" fit="cover" lazy/>
            </div>

            <ul class="info">
                <li>{{userModel.nickName}}</li>
                <li>會員推薦碼：{{userModel.userCode}}</li>
                <li>
                    <el-button class="edit" round>
                        編輯我的資料 <img src="@/assets/images/edit.svg" alt="">
                    </el-button>
                </li>
            </ul>
        </div>
        <div v-if="!isLogin" class="account"  @click="$router.push({ name: 'Login'})" >

            <div class="user_image">
                <div class="image_empty"/>
            </div>

            <div class="info">
                <el-button round class="login">登入｜註冊</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCryptoUserInfo} from "@/util/cryptoLocalStorage";

    export default {
        name: "App",
        data() {
            return {
                userModel: {
                    nickName: "",
                    userCode: "",
                    userImage: "",
                },
                isLogin: this.$auth.isAdminLogin(true),
            }
        },
        created() {

        },
        mounted() {
            this.getLoginState();
            this.$root.$on('isLogout', () => {
                this.getLoginState();
            });

        },
        destroyed() {
            this.$root.$off('isLogout');
        },
        methods: {

            getLoginState: function () {
                this.isLogin = this.$auth.isAdminLogin(true);
                if (this.isLogin) {
                    // let userInfo = localStorage.getItem('userInfo');
                    const userData = getCryptoUserInfo();
                    if (this.$public.notNull(userData)) {
                        this.userModel.userImage = userData.picture;
                        this.userModel.nickName = userData.nickName;
                        this.userModel.userCode = userData.userCode;
                    }

                } else {
                    this.userModel.nickName = "";
                    this.userModel.userCode = "";
                    this.userModel.userImage = "";
                }
            }
        }
    }
</script>
